var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('span',{class:['inline-flex items-center px-2 py-1 rounded font-bold'],style:(_vm.colorStyle)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }